'use strict';
const mmWidgets = require('./mm-widgets'),
	cleanNonPrintable = require('@mindmup/js-utils/src/clean-non-printable'),
	removeExtraSpaces = require('@mindmup/js-utils/src/remove-extra-spaces');
require('./display-error');
mmWidgets.fn.crowdlinkSigninWidget = function ({crowdlinkAuthenticator, fileId}) {
	return mmWidgets.each(this, function () {
		const element = this,
			displayNameInput = element.find('[name="crowdlink-display-name"]'),
			passwordInput = element.find('[name="crowdlink-password"]'),
			signinButton = element.find('[data-mm-role~="crowdlink-signin"]'),
			signinSection = element.find('[data-mm-section~="crowdlink-signin"]'),
			signIn = async () => {
				const password = passwordInput.val(),
					displayName = displayNameInput.val(),
					displayNameSane = removeExtraSpaces(cleanNonPrintable(displayName)).replace(/[\r\n]/g, ' ').trim();
				if (!fileId) {
					signinSection.displayError('no-file-id');
				} else if (!displayName) {
					signinSection.displayError('crowdlink-no-display-name');
				} else if (!displayNameSane) {
					signinSection.displayError('crowdlink-invalid-display-name');
				} else {
					try {
						element.addClass('hidden');
						await crowdlinkAuthenticator.authenticate({fileId, password, displayName: displayNameSane});
					} catch (reason) {
						element.removeClass('hidden');
						if (['crowdlink-capacity-exceeded', 'not-authenticated'].includes(reason)){
							signinSection.displayError(reason);
						} else {
							signinSection.displayError('crowdlink-signin-failed');
						}
					}
				}
				element.trigger('sign-in-end');
			};
		signinButton.click(signIn);

	});
};
